// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNavBarComponent {
  z-index: 1;
  width: 280px;
  min-width: 280px;
  text-align: left;
  background-color: #ffffff;
  border-right: 1px solid #e8e9e9;
  display: inline-block;
  padding-bottom: 70px;
}
.sideNavBarComponent .popoverStyles {
  position: absolute;
  color: black;
  width: 340px;
  z-index: 100;
  left: 20.2rem;
  top: 9rem;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 24px;
}
.sideNavBarComponent .popoverStyles .headerRow {
  display: flex;
  justify-content: space-between;
}
.sideNavBarComponent .popoverStyles .headerRow .left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.sideNavBarComponent .popoverStyles .headerRow .right {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #49ae9e;
  cursor: pointer;
}
.sideNavBarComponent .popoverStyles .contentList {
  position: relative;
  top: 8px;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem {
  margin-top: 16px;
  height: 50px;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem .titleRow {
  display: flex;
  justify-content: space-between;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem .titleRow .left {
  display: flex;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem .titleRow .left .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem .titleRow .left .date {
  position: relative;
  left: 3px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.sideNavBarComponent .popoverStyles .contentList .notificationItem .notificationText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.sideNavBarComponent .headerInfo {
  width: 81.538%;
  position: relative;
  top: 10px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  margin-bottom: 42px;
}
.sideNavBarComponent .headerInfo .logoArea {
  display: flex;
  align-items: center;
}
.sideNavBarComponent .headerInfo .logoArea .logoData {
  margin-left: 10px;
}
.sideNavBarComponent .headerInfo .logoArea .label-wesop {
  background-color: white;
  border: none;
  width: 140px;
  position: relative;
  top: 24px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #353d47;
  display: inline-block;
}
.sideNavBarComponent .headerInfo .logoArea .label-wesop:focus-visible {
  outline: none;
}
.sideNavBarComponent .headerInfo .logoArea .dateCountDown {
  height: 19px;
  width: 85px;
  position: relative;
  top: 26px;
  display: block;
  position: relative;
  font-family: "SUIT";
  font-size: 12px;
  border-radius: 2px;
  height: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.sideNavBarComponent .image {
  display: inline-block;
  position: relative;
  height: 21.86px;
  width: 20px;
  top: 12px;
}
.sideNavBarComponent .notifications {
  width: 81.538%;
  margin: auto;
  margin-top: 23px;
}
.sideNavBarComponent .parent {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.sideNavBarComponent .notificationLabel {
  color: #353d47;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
  position: relative;
  bottom: 6px;
  left: 11px;
}
.sideNavBarComponent .notificationImage {
  display: inline-block;
  height: 24px;
  width: 24px;
}
.sideNavBarComponent .notificationCount {
  position: relative;
  border-radius: 12px;
  height: 24px;
  width: 24px;
  text-align: center;
  background: #d9d9d9;
  display: inline-block;
  bottom: 9.5px;
  left: 20px;
}
.sideNavBarComponent .countText {
  position: relative;
  top: 3px;
  text-decoration: none !important;
}
.sideNavBarComponent .divider {
  width: 81.538%;
  position: relative;
  margin: auto;
  margin-top: 25px;
  margin-bottom: 29px;
  border: 1px solid #e8e9e9;
}
.sideNavBarComponent .notificationMenuItem {
  width: 97%;
  position: relative;
  margin: auto;
  font-size: 14px;
  font-weight: 500;
  color: #505054;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
}
.sideNavBarComponent .notificationMenuItem .titleContainer {
  margin-top: 13.5px;
  margin-bottom: 13.5px;
  margin-left: 3.23%;
  margin-right: 3.23%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.sideNavBarComponent .notificationMenuItem .titleImage {
  height: 24px;
  width: 24px;
  display: inline-block;
  position: relative;
  left: 4px;
  top: 2px;
}
.sideNavBarComponent .notificationMenuItem .titleText {
  display: inline-block;
  position: relative;
  left: 10px;
  bottom: 2px;
  color: #363d47;
}
.sideNavBarComponent .notificationMenuItem .notificationCount {
  display: inline-block;
  position: relative;
  font-size: 12px;
  left: 15px;
  bottom: 2px;
  background-color: #e47c77;
  text-align: center;
  color: white;
  height: 18px;
  width: 18px;
}
.sideNavBarComponent .notificationMenuItem .notificationCount .number {
  position: relative;
  bottom: 1.5px;
}
.sideNavBarComponent .notificationMenuItem .setNotification {
  display: inline-block;
  position: relative;
  font-size: 12px;
  margin-top: 13.5px;
  margin-right: 15px;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  padding: 3px 8px;
  height: 27px;
}
.sideNavBarComponent .notificationMenuItem:hover {
  background-color: rgb(229, 244, 242);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/sideNavBar/SideNavBar.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,oBAAA;AACJ;AAEI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;AAAR;AAEQ;EACI,aAAA;EACA,8BAAA;AAAZ;AACY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAChB;AACY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAChB;AAEQ;EACI,kBAAA;EACA,QAAA;AAAZ;AACY;EACI,gBAAA;EACA,YAAA;AAChB;AACgB;EACI,aAAA;EACA,8BAAA;AACpB;AAAoB;EACI,aAAA;AAExB;AADwB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAG5B;AADwB;EACI,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAG5B;AAGgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADpB;AAOI;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAOQ;EACI,aAAA;EACA,mBAAA;AALZ;AASY;EACI,iBAAA;AAPhB;AASY;EACI,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAPhB;AAUY;EACI,aAAA;AARhB;AAUY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARhB;AAaI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AAXR;AAcI;EACI,cAAA;EACA,YAAA;EACA,gBAAA;AAZR;AAeI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AAbR;AAgBI;EACI,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAdR;AAgBI;EACI,qBAAA;EACA,YAAA;EACA,WAAA;AAdR;AAgBI;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;AAdR;AAgBI;EACI,kBAAA;EACA,QAAA;EACA,gCAAA;AAdR;AAiBI;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAfR;AAkBI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AAhBR;AAkBQ;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAhBZ;AAmBQ;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAjBZ;AAoBQ;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAlBZ;AAoBQ;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAlBZ;AAmBY;EACI,kBAAA;EACA,aAAA;AAjBhB;AAqBQ;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAnBZ;AAuBI;EACI,oCAAA;EACA,kBAAA;AArBR","sourcesContent":[".sideNavBarComponent {\n    z-index: 1;\n    width: 280px;\n    min-width: 280px;\n    text-align: left;\n    background-color: #ffffff;\n    border-right: 1px solid #e8e9e9;\n    display: inline-block;\n    padding-bottom: 70px;\n    // overflow-y: scroll; \n\n    .popoverStyles {\n        position: absolute;\n        color: black;\n        width: 340px;\n        z-index: 100;\n        left: 20.2rem;\n        top: 9rem;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1);\n        border-radius: 16px;\n        padding: 24px;\n\n        .headerRow {\n            display: flex;\n            justify-content: space-between;\n            .left {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                color: #333333;\n            }\n            .right {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 12px;\n                line-height: 18px;\n                color: #49ae9e;\n                cursor: pointer;\n            }\n        }\n        .contentList {\n            position: relative;\n            top: 8px;\n            .notificationItem {\n                margin-top: 16px;\n                height: 50px;\n\n                .titleRow {\n                    display: flex;\n                    justify-content: space-between;\n                    .left {\n                        display: flex;\n                        .title {\n                            font-family: 'Spoqa Han Sans Neo';\n                            font-style: normal;\n                            font-weight: 700;\n                            font-size: 14px;\n                            line-height: 20px;\n                            color: #505054;\n                        }\n                        .date {\n                            position: relative;\n                            left: 3px;\n                            font-family: 'Spoqa Han Sans Neo';\n                            font-style: normal;\n                            font-weight: 400;\n                            font-size: 12px;\n                            line-height: 18px;\n                            color: #999999;\n                        }\n                    }\n                    .right {\n                    }\n                }\n                .notificationText {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n            }\n        }\n    }\n\n    .headerInfo {\n        width: 81.538%;\n        position: relative;\n        top: 10px;\n        margin: auto;\n        display: flex;\n        justify-content: space-between;\n        margin-top: 32px;\n        margin-bottom: 42px;\n\n        .logoArea {\n            display: flex;\n            align-items: center;\n\n            .HQLogo {\n            }\n            .logoData {\n                margin-left: 10px;\n            }\n            .label-wesop {\n                background-color: white;\n                border: none;\n                width: 140px;\n                position: relative;\n                top: 24px;\n                font-family: 'Noto Sans KR';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 26px;\n                color: #353d47;\n                display: inline-block;\n            }\n\n            .label-wesop:focus-visible {\n                outline: none;\n            }\n            .dateCountDown {\n                height: 19px;\n                width: 85px;\n                position: relative;\n                top: 26px;\n                display: block;\n                position: relative;\n                font-family: 'SUIT';\n                font-size: 12px;\n                border-radius: 2px;\n                height: 20px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n        }\n    }\n\n    .image {\n        display: inline-block;\n        position: relative;\n        height: 21.86px;\n        width: 20px;\n        top: 12px;\n    }\n\n    .notifications {\n        width: 81.538%;\n        margin: auto;\n        margin-top: 23px;\n    }\n\n    .parent {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .notificationLabel {\n        color: #353d47;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        display: inline-block;\n        position: relative;\n        bottom: 6px;\n        left: 11px;\n    }\n    .notificationImage {\n        display: inline-block;\n        height: 24px;\n        width: 24px;\n    }\n    .notificationCount {\n        position: relative;\n        border-radius: 12px;\n        height: 24px;\n        width: 24px;\n        text-align: center;\n        background: #d9d9d9;\n        display: inline-block;\n        bottom: 9.5px;\n        left: 20px;\n    }\n    .countText {\n        position: relative;\n        top: 3px;\n        text-decoration: none !important;\n    }\n\n    .divider {\n        width: 81.538%;\n        position: relative;\n        margin: auto;\n        margin-top: 25px;\n        margin-bottom: 29px;\n        border: 1px solid #e8e9e9;\n    }\n\n    .notificationMenuItem {\n        width: 97%;\n        position: relative;\n        margin: auto;\n        font-size: 14px;\n        font-weight: 500;\n        color: #505054;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        display: flex;\n        justify-content: space-between;\n\n        .titleContainer {\n            margin-top: 13.5px;\n            margin-bottom: 13.5px;\n            margin-left: 3.23%;\n            margin-right: 3.23%;\n            cursor: pointer;\n            display: flex;\n            justify-content: space-between;\n        }\n\n        .titleImage {\n            height: 24px;\n            width: 24px;\n            display: inline-block;\n            position: relative;\n            left:4px;\n            top:2px;\n        }\n\n        .titleText {\n            display: inline-block;\n            position: relative;\n            left: 10px;\n            bottom: 2px;\n            color: #363d47;\n        }\n        .notificationCount {\n            display: inline-block;\n            position: relative;\n            font-size: 12px;\n            left: 15px;\n            bottom: 2px;\n            background-color: #e47c77;\n            text-align: center;\n            color: white;\n            height: 18px;\n            width: 18px;\n            .number {\n                position: relative;\n                bottom: 1.5px;\n            }\n        }\n\n        .setNotification {\n            display: inline-block;\n            position: relative;\n            font-size: 12px;\n            margin-top: 13.5px;\n            margin-right: 15px;\n            border: 1px solid #e1e1e1;\n            border-radius: 6px;\n            padding: 3px 8px;\n            height: 27px;\n        }\n    }\n\n    .notificationMenuItem:hover {\n        background-color: rgb(229, 244, 242);\n        border-radius: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
